import Vue from 'vue'
import request from './request'
import requestUrl from './requestUrl'
import requestParam from './requestParam'
import lodash from 'lodash'
import { globalConfig } from '../config/global.js'

class ActionManager {
    constructor() {
    }

    addAction(id, url, type) {
        let obj = null;
        if (this[id] == null) {
            obj = {
                url,
                type
            }

            this[id] = obj;
        }

        return this;
    }

    hasAction(id) {
        return (this[id] != null);
    }

    getAction(id) {
        return this[id];
    }

    removeAction(id) {
        if (this[id] != null)
            delete this[id];
        return this;
    }

    doAction(id, params, options) {
        let action = this.getAction(id);
        if (action != null)
            return this.exec(action.url, action.type, params, options);
        else
            return Promise.reject('没有找到相关操作！');
    }

    exec(url, type, params, options, dataType) {
        if (options == null) options = {};
        let tempOption = lodash.cloneDeep(options);

        tempOption.url = requestUrl(url);
        tempOption.method = type;

        if (type.toLowerCase() === 'get') {
            tempOption.params = requestParam(params, type, false);
            return request(tempOption);
        }
        else if (type.toLowerCase() === 'post') {
            tempOption.data = requestParam(params, type, false, dataType);
            return request(tempOption);
        }
        else {
            return Promise.reject('未知的操作类型' + type + '！');
        }
    }

    download(url, params, fileName) {
        return new request({
            url: requestUrl(url),
            method: 'get',
            params: requestParam(params, 'get', false),
            responseType: 'blob',
            transformResponse: function(data) {
                let url = window.URL.createObjectURL(data);
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', fileName);
                document.body.appendChild(link)
                link.click();
            }
        })
    }
};

const actionManager = new ActionManager();

/**
 * 下载文件
 * @param {*} url           下载文件的url
 * @param {*} params        下载的参数
 * @param {*} fileName      本地保存文件名
 */
Vue.prototype.download = function(url, params, fileName) {
    return actionManager.download(url, params, fileName);
};

/**
 * 执行url操作
 * @param {*} url           要执行的url
 * @param {*} type          操作类型（post、get）
 * @param {*} params        操作的参数
 * @param {*} option        操作的选项（showMask是否显示遮罩）
 */
Vue.prototype.doUrl = function(url, type, params, axiosOption, option, dataType = 'form') {
    option = lodash.merge(globalConfig.httpOption, option);
    axiosOption = lodash.merge(globalConfig.axiosOption, axiosOption);

    return new Promise((resolve, reject) => {
        if (option.showMask) {
            this.showMask(option.showMask);
            actionManager.exec(url, type, params, axiosOption, dataType).then(res => {
                if (option.showMask)
                    this.showMask(false);
                var data = res.data;
                if (data && data.success) {
                    resolve(data);
                } else {
                    if (option.showError)
                        this.$message.error({message: data.errorMessage, showClose: true});
                    reject(data);
                }
            }).catch(err => {
                if (option.showMask)
                    this.showMask(false);
                if (option.showError)
                    this.$message.error({message: err.errorMessage ? err.errorMessage : '网络请求错误', showClose: true});
                reject(err);
            });
        }
    });
};

/**
 * 询问后根据id执行http操作
 * @param {*} id            要执行的http操作的id
 * @param {*} params        执行的操作的参数
 * @param {*} option        询问选项（text询问的文字）
 */
Vue.prototype.doActionAfterConfirm = function(id, params, axiosOption, confirmOption) {
    let defaultOption = lodash.merge(globalConfig.confirmOption, confirmOption);

    return this.$confirm(confirmOption.text, '', defaultOption).then(() => {
        return this.doAction(id, params, axiosOption);
    });
};

/**
 * 根据id执行http操作
 * @param {*} id            要执行的http操作的id
 * @param {*} params        执行的操作的参数
 * @param {*} option        操作的选项（showMask是否显示遮罩）
 */
Vue.prototype.doAction = function(id, params, axiosOption, option) {
    option = lodash.merge(globalConfig.httpOption, option);
    axiosOption = lodash.merge(globalConfig.axiosOption, axiosOption);

    return new Promise((resolve, reject) => {
        this.showMask(option.showMask);
        actionManager.doAction(id, params, axiosOption)
            .then((resp) => {
                if (option.showMask)
                    this.showMask(false);
                var data = resp.data;
                if (data && data.success) {
                    resolve(data);
                } else {
                    if (option.showError)
                        this.$message.error({message: data.errorMessage, showClose: true});
                    reject(data);
                }
            }).catch(err => {
                if (option.showMask)
                    this.showMask(false);
                if (option.showError)
                    this.$message.error({message: err, showClose: true});
                reject(err);
            });
    });
};

/**
 * 在询问后执行url操作
 * @param {*} url           要执行的url
 * @param {*} type          操作类型（post、get）
 * @param {*} params        操作的参数
 * @param {*} confirmOption 询问选项（text询问的文字）
 */
Vue.prototype.doUrlAfterConfirm = function(url, type, params, axiosOption, confirmOption) {
    let defaultOption = lodash.merge(globalConfig.confirmOption, confirmOption);

    return this.$confirm(confirmOption.text, '', defaultOption).then(() => {
        return this.doUrl(url, type, params, axiosOption);
    });
};

Vue.prototype.showConfirm = function(confirmOption) {
    let defaultOption = lodash.merge(globalConfig.confirmOption, confirmOption);
    return this.$confirm(confirmOption.text, '', defaultOption);
};



// WEBPACK FOOTER //
// ./src/core/http/index.js